import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import DocumentActions from '~/actions/document_actions';
import NotificationButton from '~/components/Notifications/Button';
import DocumentUploader from '~/components/navigation/document_uploader';
import DocumentLimitAlertChecker from '~/components/shared/document_limit_alert_checker';
import DrawerContext from '~/contexts/DrawerContext';
import { captureEvent } from '~/helpers/capture_posthog_event';
import HelpCenter from './help_center';
import NavBarSupportedContent from './nav_bar_supported_content';

class RetentionNavContent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading:      false,
      showLimitAlert: false,
    };

    this.documentUploaderRef = React.createRef();
  }

  handleUploadComplete = () => {
    DocumentActions.loadDocuments();
  };

  handleDocumentUploadClick = () => {
    this.documentUploaderRef.current.handleFileSelect();
  };

  handleLoadingStateChange = (isLoading) => {
    this.setState({ isLoading });
  };

  setShowLimitAlert = (showLimitAlert) => {
    this.setState({ showLimitAlert });
  };

  onNewTeamMemberClick = (e) => {
    e.preventDefault();

    const { openDrawer } = this.context;
    const { abilities } = Rails;

    openDrawer('team-member', {
      externalRolesOnly: !abilities.manageCurrentTeam,
    });
  };

  onAddVideoClick = async (e) => {
    e.preventDefault();

    // Lazy load VideosModal to avoid loading video.js (1.7 MB) on every page
    const { mountVideosModal } = await import(
      /* webpackChunkName: "videos-modal" */ '~/components/modals/videos/VideosModal'
    );

    mountVideosModal({
      modalClass:       'modal modal-overlay',
      dialogClass:      'modal-dialog modal-lg',
      skipVideoLibrary: true,
    });

    captureEvent('video_page_add_video');
  };

  renderActionButton() {
    const { abilities } = Rails;
    const { location } = this.props;
    const { isLoading, showLimitAlert } = this.state;
    const isDocumentPage =
      location.pathname === '/retention/documents' ||
      location.pathname === '/retention/documents/trash';
    const isVideoPage =
      location.pathname === '/retention/videos' ||
      location.pathname === '/retention/videos/trash';

    if (isDocumentPage) {
      return (
        <DocumentLimitAlertChecker
          showLimitAlert={showLimitAlert}
          setShowLimitAlert={this.setShowLimitAlert}
          placement="bottom"
        >
          <li className="nav-item mr20-md-up">
            <a
              className={`nav-link btn btn-blue btn-wide text-white ${isLoading ? 'disabled' : ''}`}
              href="#"
              onClick={this.handleDocumentUploadClick}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={isLoading ? 'spinner' : ['far', 'fa-plus']} spin={isLoading} />
              {' '}
              Add Document
            </a>
            <DocumentUploader
              ref={this.documentUploaderRef}
              onUploadComplete={this.handleUploadComplete}
              onLoadingStateChange={this.handleLoadingStateChange}
              setShowLimitAlert={this.setShowLimitAlert}
            />
          </li>
        </DocumentLimitAlertChecker>
      );
    }

    if (isVideoPage) {
      return (
        <li className="nav-item mr20-md-up">
          <a
            className="nav-link btn btn-blue btn-wide text-white"
            href="#add-video"
            onClick={this.onAddVideoClick}
          >
            <FontAwesomeIcon icon={['far', 'fa-plus']} />
            {' '}
            Add Video
          </a>
        </li>
      );
    }

    if (!abilities.retention) {
      return null;
    }

    return (
      <li className="nav-item mr20-md-up">
        <a
          className="nav-link btn btn-blue btn-wide text-white"
          href="#new-team-member-drawer"
          onClick={this.onNewTeamMemberClick}
        >
          <FontAwesomeIcon icon={['far', 'fa-plus']} />
          {' '}
          Add Team Member
        </a>
      </li>
    );
  }

  render() {
    return (
      <ul className="navbar-nav ml-auto mr-auto-sm-down">
        <div className="d-flex">
          <NotificationButton />
          <HelpCenter />
        </div>
        {this.renderActionButton()}
        <NavBarSupportedContent />
      </ul>
    );
  }
}

RetentionNavContent.propTypes = {
  location: PropTypes.object.isRequired,
};
RetentionNavContent.contextType = DrawerContext;

export default withRouter(RetentionNavContent);
